



































import { createComponent, onMounted, onUnmounted, ref, watch, computed } from '@vue/composition-api'
import { fabric } from 'fabric'
import BottomBar from './BottomBar.vue'
import { handleDrag } from './utils/drag'
import { useZoom } from './utils/hooks'
import { Drag, Shape } from './shape'
import NewFoldTree from '@/components/NewFoldTree.vue'
import { IFileItem } from '@/service/public'
import { StartCheckType } from '@/components/DuplicateNameConfirm.vue'
import { Drawer, Loading } from 'element-ui'
import { CoLoadingComponent } from '@heytap/cook-ui/types/loading'
import { getEnv, copyToClipboard } from '@/helpers/common'
import { Message, MessageBox } from '@heytap/cook-ui'
import { envMap } from '@/constant'
interface CheckBoxType {
    startCheck: (obj: StartCheckType) => {}
}
function handleDialog({ emit }) {
    const drawerRef = ref<Drawer>(void null)
    const drawerVisible = ref(false)
    const moveFile = async (params: StartCheckType) => {
        emit('move-file', params)
    }
    const showFoldTree = () => {
        drawerVisible.value = true
    }
    const closeFildTree = () => {
        drawerVisible.value = false
    }
    return {
        moveFile,
        drawerRef,
        drawerVisible,
        showFoldTree,
        closeFildTree,
    }
}
export default createComponent({
    components: {
        BottomBar,
        NewFoldTree,
    },
    props: {
        imgInfo: {
            type: Object,
            default: () => {
                return {}
            },
        },
        isShowImgPreview: {
            type: Boolean,
            default: false,
        },
        currentImgIndex: {
            type: Number,
            default: 0,
        },
    },

    setup(props, setupContext) {
        const canvas = ref<fabric.Canvas>()
        const useHandleDialog = handleDialog(setupContext)
        const useHandleDrag = handleDrag(useHandleDialog)
        const { zoomDown: zoomDownFn, zoomUp: zoomUpFn, zoomToFitCanvas, onMouseWheel } = useZoom(canvas)
        const isOrigin = ref(false)
        const loading = ref<CoLoadingComponent>(null)
        const imgName = computed(() => props.imgInfo.name || '')
        const handleRender = () => {
            canvas.value.renderAll()
            new Shape(canvas.value)
            new Drag(canvas.value)
        }
        const zoomDown = () => {
            isOrigin.value = false
            zoomDownFn()
        }
        const zoomUp = () => {
            isOrigin.value = false
            zoomUpFn()
        }
        const zoomOrigin = () => {
            if (isOrigin.value) return false
            isOrigin.value = true
            zoomToFitCanvas(true)
            handleRender()
        }
        const zoomFit = () => {
            isOrigin.value = false
            zoomToFitCanvas()
        }
        const zoomCopyUrl = () => {
            const ImagUrl = envMap[getEnv()] && envMap[getEnv()].fileHost+`api/downloadFile?id=${props.imgInfo.id}`
            MessageBox.confirm(`链接：${ImagUrl}`, '生成文件链接', {
                confirmButtonText: '复制链接',
                cancelButtonText: '取消',
            })
                .then(() => {
                    copyToClipboard(ImagUrl)
                })
                .catch(() => {
                    console.log('cancel')
                })
        }
        const zoomCopyName = () => {
            const name = imgName.value
            if(typeof name === 'string') {
                copyToClipboard(name).then(() => {
                    Message.success('复制成功')
                })
            }
        }
        const onWindowResize = (e: Event) => {
            if (props.isShowImgPreview) {
                canvas.value.setWidth(document.body.clientWidth)
                canvas.value.setHeight(document.body.clientHeight)
                zoomToFitCanvas()
                e.preventDefault()
            }
        }
        const initCanvas = id => {
            // 加载图片
            loading.value = setupContext.root.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            try {
                const img = new Image()
                img.src = `/api/downloadFile?id=${id}`
                img.onload = async () => {
                    canvas.value.backgroundImage = new fabric.Image(img)
                    canvas.value.setWidth(document.body.clientWidth)
                    canvas.value.setHeight(document.body.clientHeight)
                    isOrigin.value = false
                    zoomToFitCanvas()
                    handleRender()
                    ;(loading.value as CoLoadingComponent).close()
                }
                img.onerror = async () => {
                    Message.error('图片加载失败')
                    ;(loading.value as CoLoadingComponent).close()
                    setTimeout(() => {
                        setupContext.emit('close-canvas')
                    }, 1000)
                }
            } catch (error) {
                loading.value.close()
            }
        }
        watch(
            () => props.imgInfo.id,
            async val => {
                if (!val) return
                initCanvas(val)
            },
            {
                lazy: true,
            }
        )
        watch(
            () => props.isShowImgPreview,
            val => {
                if (!val) {
                    useHandleDialog.drawerVisible.value = false
                }
            }
        )
        const resize = (imgInfo: IFileItem) => {
            if (!imgInfo.id) return
            initCanvas(imgInfo.id)
        }
        // const onKeyDown = e => {
        //   if (e.key === "Escape") {
        //     (loading.value as CoLoadingComponent).close()
        //     setupContext.emit("close-canvas");
        //   }
        // };
        onMounted(() => {
            canvas.value = new fabric.Canvas('canvas', {
                backgroundColor: '#121a26',
                skipOffscreen: true,
                fireRightClick: true,
                selection: false,
            })
            canvas.value.setWidth(document.body.clientWidth)
            canvas.value.setHeight(document.body.clientHeight)
            window.addEventListener('resize', onWindowResize)
            // window.addEventListener("keydown", onKeyDown);
        })
        onUnmounted(() => {
            window.removeEventListener('resize', onWindowResize)
            // window.removeEventListener("keydown", onKeyDown);
        })

        return {
            canvas,
            zoomDown,
            zoomUp,
            zoomToFitCanvas,
            zoomFit,
            zoomOrigin,
            zoomCopyUrl,
            zoomCopyName,
            isOrigin,
            onMouseWheel,
            resize,
            loading,
            ...useHandleDialog,
            imgName,
        }
    },
})
